/**
 * Created by wuyanbin on 2019/5/27
 */
/**
 * @desc 查看合同 （打印和下载）
 * orderId: 订单ID
 */
import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import styled from 'styled-components';
import { WhiteSpace } from '@/components';
import ReactDOM from 'react-dom';
import store, { dispatch } from '@@/store';
import { Provider, connect } from '@souche-f2e/muji';
const mapStateToProps = (rootState) => ({ showContract: rootState.showContract });
class ShowContract extends Component {
    constructor(props) {
        super(props);
        // 打印
        this.printing = () => {
            // const el = document.getElementById('print__html');
            // const iframe = document.createElement('IFRAME');
            // iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:500px;top:500px;');
            // document.body.appendChild(iframe);
            // // @ts-ignore
            // iframe.contentWindow.document.body.innerHTML = el.innerHTML;
            // // @ts-ignore
            // iframe.contentWindow.focus();
            // // @ts-ignore
            // iframe.contentWindow.print();
            // ---------
            const content = document.getElementById('print__html');
            const pri = document.getElementById('ifmcontentstoprint').contentWindow;
            pri.document.open();
            pri.document.write(content.innerHTML);
            pri.document.close();
            pri.focus();
            pri.print();
        };
        // 隐藏弹窗
        this.hideModal = () => {
            dispatch.showContract.hide();
        };
    }
    render() {
        const { isShow, contractLinkImg, contractLinkPdf } = this.props.showContract;
        return (<div>
        <iframe id="ifmcontentstoprint" style={{ height: 0, width: 0, position: 'absolute' }}/>
        <Modal title="合同查看" visible={isShow} footer={null} onCancel={this.hideModal} width={800}>
          <div id="print__html" style={{ height: 500, overflow: 'scroll' }}>
            {contractLinkImg.map((url, i) => {
            return <img style={{ width: '100%', marginBottom: '1px' }} src={url} key={i}/>;
        })}
          </div>
          <WhiteSpace h={10}/>
          <Foot className="flex__row-end">
            <Button className="opt--print" onClick={this.printing}>打印</Button>
            <a className="opt--link" href={contractLinkPdf} download={'合同'} target="_blank">下 载</a>
          </Foot>
        </Modal>
      </div>);
    }
}
const ShowContractComponent = connect(mapStateToProps, null, null, { forwardRef: true })(ShowContract);
export default ShowContractComponent;
/**
 * API
 * */
let componentRef = '';
const createShowContract = () => {
    const div = document.createElement('div');
    div.className = 'souche-show-contract';
    document.body.appendChild(div);
    // @ts-ignore
    const refFn = (ref) => {
        componentRef = ref;
    };
    const Create = React.createElement;
    const component = (<Provider store={store}>
      {Create(ShowContractComponent, {
        ref: refFn,
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function showContract({ orderId, callback }) {
    if (!componentRef) {
        createShowContract();
    }
    dispatch.showContract.showModal({ orderId, callback }).then(() => {
        dispatch.showContract.getContractInfo({});
    });
}
const Foot = styled.div `
  .opt--print {
    margin-right: 10px;
  }
  .opt--link {
    display: inline-block;
    height: 32px;
    line-height: 30px;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.65);
    border: 1px solid transparent;
    background-color: #fff;
    border-color: #d9d9d9;
    &:hover, &:focus {
      color: #ff7b42;
      background-color: #fff;
      border-color: #ff7b42;
    }
  }
`;
